module.exports = __webpack_public_path__ + "static/media/ride-active.d056c1ba.svg";